/** @format */

module.exports = (i18n) => {
  return [
    {
      path: "/chapter1",
      params: {
        title: () => i18n.t("overview:step_one"),
      },
      screens: [
        {
          type: "email",
          params: {
            collectBlackbox: true,
          },
        },
      ],
    },
    {
      path: "/chapter2",
      params: {
        title: () => i18n.t("overview:step_two"),
      },
      screens: [
        {
          type: "password",
          params: {
            conditions: [
              {
                property: "partner.variant",
                not: true,
                value: ["MGA", "MGA-otp"],
              },
              {
                property: "socialMediaData.socialSignIn",
                value: false,
              },
            ],
          },
        },
        {
          type: "personal-password",
          params: {
            conditions: [
              {
                property: "partner.variant",
                value: ["MGA", "MGA-otp"],
              },
              {
                property: "socialMediaData.socialSignIn",
                value: false,
              },
            ],
          },
        },
        {
          type: "phone-number",
        },
        { type: "email-validation", params: { validation: true } },
      ],
    },
    {
      path: "/chapter3",
      params: {
        title: () => i18n.t("overview:step_three"),
        noTitleScreens: ["document-uploader"],
      },
      screens: [
        {
          type: "last-name",
          params: {
            conditions: [{ property: "app.country.code", value: "JP" }],
          },
        },
        {
          type: "first-name",
          params: {
            conditions: [{ property: "app.country.code", value: "JP" }],
          },
        },
        {
          type: "full-name",
          params: {
            conditions: [
              {
                property: "app.country.code",
                not: true,
                value: "JP",
              },
            ],
          },
        },
        { type: "postal-code" },
        {
          type: "question.state",
          params: {
            list: true,
            scrollShadow: true,
            text: () => i18n.t("postalCode:select_province", { context: "us" }),
            dispatchKey: "updateUser",
            propertyName: "province",
            currentAnswer: (store) => store.state.user.state,
            answers: (store) => {
              return store.state.app.country.provinces.map((p) => ({
                id: p.ISOCode.slice(-2),
                label: p.name,
              }));
            },
            conditions: [
              {
                property: "user.province",
                value: false,
              },
              {
                property: "app.postalArea.streets",
                value: false,
              },
              {
                property: "app.country.code",
                value: "US",
              },
            ],
          },
        },
        { type: "city" },
        { type: "street-name" },
        { type: "house-number" },
        {
          type: "question.province",
          params: {
            list: true,
            scrollShadow: true,
            text: () => i18n.t("postalCode:select_province"),
            dispatchKey: "updateUser",
            propertyName: "province",
            showKeyboardOnNextScreen: true,
            currentAnswer: (store) => store.state.user.province,
            answers: (store) => {
              return store.state.app.country.provinces
                .filter((item) => {
                  return store.state.customData.hideSHProvince === true ||
                    (store.state.customData.hideSHProvince === undefined &&
                      store.state.partner.hideSHProvince === true)
                    ? item.ISOCode !== "DE-SH"
                    : true;
                })
                .map((p) => ({
                  id: p.ISOCode.slice(-2),
                  label: p.name,
                }));
            },
            conditions: [
              {
                property: "user.province",
                value: false,
              },
              {
                property: "user.country",
                value: ["CA"],
              },
            ],
          },
        },
        {
          type: "masked-birthdate",
          params: {
            // send Iovation request
            checkBlackBoxInIovation: true,
          },
          flowConfirmation: {
            orderNo: 2,
            propertyName: "birthdate",
            labelLocale: () => i18n.t("birthdate:label"),
          },
        },
        { type: "phone-number-validation" },
        {
          type: "preGDPR",
          params: {
            screenTitle: () => i18n.t("overview:consent_header_title"),
            conditions: [
              {
                property: "partner.variant",
                value: ["core", "otp-internal"],
              },
            ],
          },
        },
        {
          type: "GDPR",
          params: {
            screenTitle: () => i18n.t("overview:consent_header_title"),
          },
        },
        {
          type: "verify-age-transition",
          params: {
            hideTitle: true,
            large: true,
            conditions: [
              {
                property: "app.country.code",
                value: "XX",
              },
            ],
          },
        },
        {
          type: "legal",
          params: {
            screenTitle: () => i18n.t("overview:summary"),
            conditions: [
              {
                property: "app.country.code",
                value: "XX",
              },
              {
                property: "idinStatus.compareSuccessCheck",
                value: false,
              },
              {
                property: "user.skipIdinValidation",
                value: false,
              },
            ],
          },
        },
        /* not roots */
        /* not roots */
      ],
    },
  ];
};



// WEBPACK FOOTER //
// ./src/partners/variant-flows/igaming.js